import { isAkeyWebview } from '@alfa-bank/newclick-helpers/utils/akey/is-akey-webview';
import { extractAppVersion } from '../headers/extract-app-version';
import { extractUserAgent } from '../headers/extract-user-agent';
import { versionPattern, webviewUaIOSPattern } from './reg-exp-patterns';
export const isAlfaMobileWebviewByUserAgent = (userAgent, appVersion) => {
    // Капсула не является AM-вебвью.
    if (userAgent && isAkeyWebview(userAgent)) {
        return false;
    }
    return ((appVersion && versionPattern.test(appVersion)) || !!userAgent?.match(webviewUaIOSPattern));
};
export const isAlfaMobileWebview = (request) => {
    const userAgent = extractUserAgent(request);
    // `app-version` в заголовках – индикатор вебвью. В iOS есть только в первом запросе от webview
    const appVersion = extractAppVersion(request);
    return isAlfaMobileWebviewByUserAgent(userAgent, appVersion);
};
